<section class="container">
    <div class="failed-po-modal-container m-4">
      <div class="modal-header">
        <h5 class="modal-title pull-left">
          {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
          <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
      </div>
      <div class="modal-body">
        <div class="modal-body__content">
          <p *ngIf="!isSuccess">{{error?.message}}</p>
          <p *ngIf="success" class="po-success">{{success}}</p>
          
          <ng-container *ngIf="message">
            <div *ngFor="let error of message; let i = index">
              <li>
                <span [ngClass]="getMessageClass(errorTypes[i])">
                  {{error}}
                </span>
              </li>
            </div>
          </ng-container>
          
          <ng-container *ngIf="isSuccess">
            <div *ngFor="let exception of error?.exception">
              <li>
                <span [ngClass]="getMessageClass(exception?.TYPE)">
                  {{exception?.PSTYP == 'D' ? 'Service' : ''}} Purchase orders can be created successfully
                </span>
              </li>
            </div>
          </ng-container>
          
          <ng-container *ngIf="!isSuccess">
            <div *ngFor="let exception of error?.exception">
              <li>
                <span [ngClass]="getMessageClass(exception?.TYPE)">
                  {{exception?.MESSAGE}} {{exception?.PSTYP == 'D' ? '(SERVICE PURCHASE)' : ''}}
                </span>
              </li>
            </div>
          </ng-container>
          
          <hr>
        </div>
      </div>
    </div>
  </section>
  